var map = {
	"./404.vue": [
		"3e58",
		"chunk-2d0c51ab"
	],
	"./AboutOurProduct.vue": [
		"36df",
		"chunk-2d0ba71b"
	],
	"./Affiliates.vue": [
		"c6d2",
		"chunk-3dd9de94"
	],
	"./AvisoLegal.vue": [
		"7e40",
		"chunk-2d0e2300"
	],
	"./Conservas.vue": [
		"27ff",
		"chunk-d816acae"
	],
	"./ContactUs.vue": [
		"6823",
		"chunk-2d0d0579"
	],
	"./Features.vue": [
		"2b26",
		"chunk-2d0bd1aa"
	],
	"./Gourmet.vue": [
		"dcf6",
		"chunk-ec27656a"
	],
	"./Hero.vue": [
		"2d0d",
		"chunk-7adf940c"
	],
	"./HeroAlt.vue": [
		"10a9",
		"chunk-15288d1c"
	],
	"./Info.vue": [
		"f786",
		"chunk-f782c928"
	],
	"./InfoCard.vue": [
		"9ddb",
		"chunk-2d0f0dff"
	],
	"./KeepInTouch.vue": [
		"dea4",
		"chunk-2d229d2a"
	],
	"./Map.vue": [
		"799b",
		"chunk-2d0d7ea1"
	],
	"./Newsletter.vue": [
		"891f",
		"chunk-2d0df20c"
	],
	"./Pinchos.vue": [
		"2e80",
		"chunk-1dbf6632"
	],
	"./PoliticaCookies.vue": [
		"cd55",
		"chunk-dd87938a"
	],
	"./PoliticaPriv.vue": [
		"f3d4",
		"chunk-2d22ca93"
	],
	"./Portada.vue": [
		"2d5a",
		"chunk-6b634bd6"
	],
	"./Pudin.vue": [
		"fa31",
		"chunk-3dd56382"
	],
	"./SocialMedia.vue": [
		"4252",
		"chunk-2d0c0691"
	],
	"./ThemeFeatures.vue": [
		"36e2",
		"chunk-2d0ba706"
	],
	"./Txangurro.vue": [
		"19d0",
		"chunk-712100c4"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "995e";
module.exports = webpackAsyncContext;